import { IUsersData, ICreateUsersResponse } from 'types/users';
import api from '../services/config/api';

export const createUser = (data: IUsersData) => api.post<ICreateUsersResponse>('/user', data);
